// Move extra filters in and out of "more" tab
function moveFilters() {
  let navwidth = 0;
  const navContainer = document.querySelector(".static-filters");
  const moreBtn = document.querySelector(".static-filters .more");
  const morewidth =
    document.querySelector(".static-filters .more").getBoundingClientRect()
      .width + 18;
  const filters = document.querySelectorAll(
    ".static-filters > .filter-wrapper:not(.more)"
  );
  const availablespace =
    document.querySelector(".static-filters").getBoundingClientRect().width -
    morewidth;
  const moreContainer = document.querySelector(".static-filters .more-filters");

  if (filters) {
    for (let i = 0; i < filters.length; i++) {
      navwidth += filters[i].getBoundingClientRect().width;
    }
  }

  if (navwidth && availablespace && filters) {
    if (navwidth > availablespace) {
      let lastItem = filters[filters.length - 1];
      if (lastItem && moreContainer) {
        lastItem.dataset.width = lastItem.getBoundingClientRect().width;
        moreContainer.insertBefore(lastItem, moreContainer.firstChild);
      }
      moveFilters();
    } else {
      if (moreContainer) {
        let firstMoreElement = moreContainer.firstChild;
        if (
          Math.floor(navwidth) + Math.floor(firstMoreElement.dataset.width) <
          availablespace
        ) {
          navContainer.insertBefore(firstMoreElement, moreBtn);
        }
      }
    }
  }

  if (moreContainer && moreBtn) {
    if (moreContainer.children.length > 0) {
      moreBtn.style.display = "block";
    } else {
      moreBtn.style.display = "none";
    }
  }
}

function openFilters() {
  document.querySelector(".static-filters .more-filters").style.display =
    "block";
}

window.addEventListener("resize", (event) => {
  moveFilters();
});
window.addEventListener("load", (event) => {
  //show filters once JS loads
  document.querySelector(".static-filters").style.opacity = "1";
  moveFilters();
  //disable click on active nav item
  document
    .querySelector(".filter--active")
    .addEventListener("click", function (event) {
      event.preventDefault();
      return false;
    });
});
//Hide more filters
document.addEventListener("click", function (event) {
  const filterContainer = document.querySelector(
    ".static-filters .more-filters"
  );
  const filterBtn = document.getElementById("filterBtn");
  if (filterContainer && filterBtn) {
    if (
      filterContainer.contains(event.target) ||
      filterBtn.contains(event.target)
    ) {
      filterContainer.style.display = "block";
    } else if (
      !filterContainer.contains(event.target) ||
      !filterBtn.contains(event.target)
    ) {
      filterContainer.style.display = "none";
    }
  }
});
